export default __webpack_public_path__ + "static/media/LOGO_GBCI_b.3774e668.png";